import { Skeleton } from "@/components/ui/skeleton";

const QuizDimensionPageSkeleton = () => {
  return (
    <div className="mx-auto w-full max-w-screen-md">
      <Skeleton className="bg-gray-200" style={{ height: "206px" }} />

      <div className="my-6 text-xl font-semibold text-[#13171B]">Temas</div>

      <div className="flex flex-col gap-4">
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton
            key={index}
            className="bg-gray-200"
            style={{ height: "76px" }}
          />
        ))}
      </div>
    </div>
  );
};

export default QuizDimensionPageSkeleton;
